import { FC } from "react";
import { Tag } from "components/atoms/Tag/Tag";

import { ITag } from "@types";

import s from "./Tag.module.scss";

interface Props {
  tags: ITag[];
}

export const Tags: FC<Props> = ({ tags }) => {
  return (
    <div className={s.Tags}>
      <ul className={s.List}>
        {tags.map((tag) => (
          <li key={`tag-${tag.label}`} className={s.TagWrapper}>
            <Tag link={tag.link} label={tag.label} />
            {tag.childrenLinks && tag.childrenLinks.length > 0 && (
              <ul className={s.ChildList}>
                {tag.childrenLinks.map((child) => (
                  <li key={`tag-${child.label}`} className={s.TagWrapper}>
                    <Tag link={child.link} label={child.label} />
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
